module.exports = __webpack_public_path__ + "static/img/7.40de7798.png";